var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelayed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon bubble") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Journey-4---Inbox",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3.3--Elements",
    transform: "translate(-771.000000, -753.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(771.000000, 740.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-bubble",
    transform: "translate(0.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "circle"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fillOpacity: 0.3,
    fill: "#7450C8",
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("g", {
    id: "stopwatch-slash",
    transform: "translate(7.000000, 6.500000)",
    fill: "#7450C8",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.6,3.63 C7.04771526,3.72941127 6.68058877,4.25771525 6.78000002,4.81 C6.87941127,5.36228474 7.40771526,5.72941124 7.96,5.63 C8.29034058,5.57292712 8.62477736,5.54282781 8.96,5.54 C12.2737085,5.54 14.96,8.2262915 14.96,11.54 C14.9571722,11.8752226 14.9270729,12.2096594 14.87,12.54 C14.7726827,13.0807885 15.1299262,13.5987916 15.67,13.7 L15.85,13.7 C16.3390037,13.7079763 16.7620327,13.3610925 16.85,12.88 C16.9428394,12.4256708 16.9930573,11.9636658 17,11.5 C16.9954268,9.71977216 16.3971916,7.99192817 15.3,6.59 L16.21,5.69 C16.6021222,5.29787783 16.6021222,4.66212217 16.21,4.27 C15.8178778,3.87787783 15.1821222,3.87787783 14.79,4.27 L13.89,5.18 C12.4908923,4.09416772 10.7710232,3.50329246 9,3.5 C8.5302786,3.49910146 8.0615249,3.54262859 7.6,3.63 Z M7,2.5 L11,2.5 C11.5522847,2.5 12,2.05228475 12,1.5 C12,0.94771525 11.5522847,0.5 11,0.5 L7,0.5 C6.44771525,0.5 6,0.94771525 6,1.5 C6,2.05228475 6.44771525,2.5 7,2.5 Z M10.49,11.58 C10.49,11.58 10.49,11.53 10.49,11.5 C10.49,11.47 10.49,11.45 10.49,11.42 L11.83,10.09 C12.0836586,9.83634143 12.1827235,9.46662601 12.089878,9.12012196 C11.9970326,8.7736179 11.7263821,8.50296743 11.379878,8.41012195 C11.033374,8.31727647 10.6636586,8.41634142 10.41,8.67 L9.08,10 L8.92,10 L2.71,3.79 C2.31787783,3.39787784 1.68212218,3.39787784 1.29000001,3.79000001 C0.897877842,4.18212218 0.897877838,4.81787783 1.29,5.21 L1.77,5.69 L2.68,6.6 C0.225431055,9.78496068 0.516397769,14.2969717 3.35971302,17.140287 C6.20302828,19.9836022 10.7150393,20.2745689 13.9,17.82 L15.29,19.21 C15.4777666,19.3993127 15.7333625,19.5057983 16,19.5057983 C16.2666375,19.5057983 16.5222334,19.3993127 16.71,19.21 C16.8993127,19.0222334 17.0057983,18.7666375 17.0057983,18.5 C17.0057983,18.2333625 16.8993127,17.9777666 16.71,17.79 L10.49,11.58 Z M9,17.5 C6.74670848,17.5062414 4.67989004,16.2494788 3.64863299,14.2460142 C2.61737593,12.2425496 2.79556626,9.83019823 4.11,8 L7.51,11.39 C7.51,11.39 7.51,11.44 7.51,11.47 C7.50196463,11.8712686 7.6550718,12.259021 7.93508495,12.5465513 C8.2150981,12.8340815 8.59865938,12.9974048 9,13 L9.08,13 L12.47,16.4 C11.4551535,17.1171583 10.2426694,17.5015193 9,17.5 Z",
    id: "Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelayed);
export default __webpack_public_path__ + "static/media/Delayed.094fe87a951a0f04292aad380a95317b.svg";
export { ForwardRef as ReactComponent };